(function () {
  'use strict';
  function holidayActive(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Toronto',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date);
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    var key = values.year + '-' + values.month + '-' + values.day;
    return key >= '2026-11-01' && key < '2027-01-01';
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {holidayActive:holidayActive}; return; }
  var script = document.currentScript || document.querySelector('[data-holiday-navigation]');
  var href = script && script.getAttribute('data-holiday-url');
  function init() {
    var track = document.getElementById('tp-explore-track');
    if (!track || !href) return;
    function sync() {
      var entry = track.querySelector('[data-holiday-entry]');
      if (!holidayActive(new Date())) { if (entry) entry.remove(); return; }
      if (entry) return;
      entry = document.createElement('a');
      entry.href = href;
      entry.className = 'tp-explore__item swish-holiday-entry';
      entry.setAttribute('data-holiday-entry', '');
      var label = document.createElement('span');
      label.className = 'tp-explore__label';
      label.textContent = 'Holiday Shop';
      entry.appendChild(label);
      track.prepend(entry);
    }
    sync();
    new MutationObserver(sync).observe(track, {childList:true});
    setInterval(sync, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
